import React from "react";
import { useField } from "formik";

import { ITeam } from "apis";

import { FIELD } from "../../constants";
import { TEAM_TYPE } from "../../types";

import { PlayerField } from "./PlayerField";
import { ThreatField } from "./ThreatField";

interface IThroughPassPanelProps {
  homeTeam?: ITeam;
  awayTeam?: ITeam;
}

export const ThroughPassPanel = ({
  homeTeam,
  awayTeam,
}: IThroughPassPanelProps) => {
  const [teamTypeField] = useField(FIELD.teamType);
  const team = teamTypeField.value === TEAM_TYPE.HOME ? homeTeam : awayTeam;
  return (
    <>
      <PlayerField showBothPlayer homeTeam={team} awayTeam={team} />
      <ThreatField />
    </>
  );
};
